import styled from 'styled-components';

const StyledCopyright = styled.div`
  color: ${({ theme }) => theme.colors.text.grey};
  font-size: ${({ theme }) => theme.fonts.sizes.mobile.medium};
  line-height: ${({ theme }) => theme.fonts.lineHeights.xLarge};
`;

export { StyledCopyright };
